var exports = {
  "Nr": "xa9f3555f--ac6eb8--card",
  "Ey": "xa9f3555f--ac6eb8--card-clickable",
  "HM": "xa9f3555f--ac6eb8--btn",
  "Pf": "xa9f3555f--ac6eb8--label",
  "Zp": "xa9f3555f--ac6eb8--layout",
  "fN": "xa9f3555f--ac6eb8--card-small",
  "hy": "xa9f3555f--ac6eb8--card-medium",
  "Qv": "xa9f3555f--ac6eb8--card-big",
  "gW": "xa9f3555f--ac6eb8--layout-wrap",
};

module.exports = exports;
